import { render } from "./chat_padrao.vue?vue&type=template&id=12a43874"
import script from "./chat_padrao.vue?vue&type=script&lang=js"
export * from "./chat_padrao.vue?vue&type=script&lang=js"

import "./chat_padrao.vue?vue&type=style&index=0&id=12a43874&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__